// @ts-nocheck
/* eslint-disable */
export const doubleArrowIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2.954 7.008a.5.5 0 0 1 .705-.054L8 10.674l4.341-3.72a.5.5 0 0 1 .651.759l-4.667 4a.5.5 0 0 1-.65 0l-4.667-4a.5.5 0 0 1-.054-.705" clip-rule="evenodd"/><path fill="currentColor" d="M3.333 4.167a.5.5 0 0 0-.325.88l4.667 4a.5.5 0 0 0 .65 0l4.667-4a.5.5 0 0 0-.325-.88z"/></svg>`,
    name: 'double-arrow' as const
};